import { render } from "./Order.vue?vue&type=template&id=2da4a46f&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=2da4a46f&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/kds/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da4a46f"]])

export default __exports__